import { createClient } from "constellation-sdk";
import { SERVICES_ANON_KEY, SERVICES_URL } from "../supabase/constants";
import { API_URL } from "./constants";

export const apiClient = createClient({
    apiUrl: API_URL!,
    servicesUrl: SERVICES_URL!,
    servicesAnonKey: SERVICES_ANON_KEY!,
})